import {
  TheExpertsNextChapter,
  getStaticProps,
} from '@public/TheExpertsNextChapter'

export { getStaticProps }

export default TheExpertsNextChapter
